import { render } from "./Home.vue?vue&type=template&id=5e9ed226&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=5e9ed226&scoped=true&lang=css"

import exportComponent from "/home/runner/work/abdc-frontend/abdc-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e9ed226"]])

export default __exports__